module.exports = __webpack_public_path__ + "img/features01.f6798811.png";